var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-wrapper",style:(_vm.wrapperStyle)},[_c('img',{staticClass:"icon-img",attrs:{"src":_vm.iconSrc,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }